import { createFileRoute } from '@tanstack/react-router';
import LinkAccountPage from 'src/features/plugins/outlook/(auth)/(setup)/link-account/page';

export const Route = createFileRoute('/plugins/outlook/_outlookAuth/_outlookSetup/link-account')({
  component: LinkAccountPage,
});
